<template>
  <!-- <div class="api-content"> -->
  <div class="api-doc">
    <div class="left_side">
      <el-autocomplete
        popper-class="my-api-search-autocomplete"
        ref="my-api-search-autocomplete"
        v-model="apiName"
        :fetch-suggestions="querySearch"
        placeholder="输入接口名称或cmd开始搜索"
        @select="handleSelectApi">
        <i
          class="el-icon-search el-input__icon"
          slot="suffix"
          @click="handleSearchApi">
        </i>
        <template slot-scope="{ item }">
          <div class="name">{{ item.value }}</div>
          <span class="addr">{{ item.cmd }}</span>
          <!-- <el-link :href="item.linkUrl" >{{item.value}}</el-link> -->
        </template>
      </el-autocomplete>
      <el-scrollbar>
        <left-mune :menuData="menuList" @setCommonUrls="setCommonUrls"></left-mune>
      </el-scrollbar>
    </div>
    <!--<el-scrollbar>-->
    <div class="right_side">
      <transition name="el-fade-in" mode="out-in">
        <router-view :parData='parData' :commonUrls='commonUrls'></router-view>
      </transition>
    </div>
    <!--</el-scrollbar>-->
  </div>
  <!-- <div class="api-foot">
      <Foot></Foot>
    </div> -->
  <!-- </div> -->
</template>

<script>
  import leftMune from "../components/leftMune.vue";
  import Foot from "../components/Foot.vue";
  import common from "../assets/js/common.js";
  import '../assets/less/api.less'

  import {mapState, mapMutations} from "vuex";

  export default {
    name: "",
    mixins: [common],
    components: {
      "left-mune": leftMune,
      Foot: Foot
    },
    data() {
      return {
        //公共调用地址
        commonUrls: {},
        parData: "",
        apiName: '',
        apiList: []
      };
    },
    created() {
      this.initCommonUrls();
      this.initApiList();
    },
    computed: {
      ...mapState(["menuList", "url", "refreshPage", "selectName"])
    },
    methods: {
      ...mapMutations([
        "setMenuList",
        "setSelectName",
        "setRefreshPage"
      ]),
      initCommonUrls() {
        let url = window.location.href;
        if (this.$root.customConfig.menuList) {
          this.setMenuList(this.$root.customConfig.menuList)
        }
        this.menuList.forEach((ele, index) => {
          if (url.indexOf(ele.index) !== -1) {
            this.setCommonUrls(ele.uri)
          }
        })
      },
      setCommonUrls(uri) {
        let urlObj = this.$root.customConfig.url && Object.keys(this.$root.customConfig.url).length > 0 ? 
          this.$root.customConfig.url : this.url;
        let devUrl = urlObj.dev; 
        let testUrl = urlObj.test;
        let prodUrl = urlObj.prod
        if (!uri) {
          uri = '/openydt/api/v2/';
        }
        if (!devUrl) {
          devUrl = "https://openapi-dev.yidianting.xin"
        }
        if (!testUrl) {
          testUrl = "https://openapi-dev.yidianting.xin"
        }
        if (!prodUrl) {
          prodUrl = "https://open.yidianting.xin"
        }
        this.commonUrls = {
          dev: devUrl + uri,
          test: testUrl + uri,
          prod: prodUrl + uri,
          third: "第三方提供基础URL+/"
        }
      },
      initDrop(selectName) {

        let url = window.location.href;
        // this.loopAuth(this.menuData.menuList, null, selectName);
      },
      loopAuth(munes, parents, selectName) {
        munes.forEach(element => {
          if (element.sub.length > 0) {
            this.loopAuth(element.sub, element, selectName);
          } else {
            //  console.log(selectName,element.linkUrl==selectName)
            if (element.linkUrl === selectName && parents) {
              // console.log('parents',parents)
              parents.isDrop = true;
              return;
            }
          }
        });
      },
      handleSearchApi(ev) {
        console.log(ev)
        if (this.apiName) {
          // var queryString = this.apiName
          // var apiList = this.apiList;
          // var results = queryString ? apiList.filter(this.createFilter(queryString)) : apiList;
          // this.$ref['my-api-search-autocomplete'].suggestions = results
          // this.querySearch(this.apiName, ev)
        }
      },  
      querySearch(queryString, cb) {
          var apiList = this.apiList;
          queryString = queryString.toLowerCase();
          var results = queryString ? apiList.filter(this.createFilter(queryString)) : apiList;
          // 调用 callback 返回建议列表的数据
          cb(results);
      },
       createFilter(queryString) {
        return (api) => {
          if(api.hidden) {
            if (api.linkUrl.indexOf(this.refreshPage) < 0) {
              return false;
            }
          }
          return (api.value.toLowerCase().indexOf(queryString) >= 0 || api.cmd.toLowerCase().indexOf(queryString) >= 0);
        };
      },
      handleSelectApi(item) {
        this.apiName = ''
        let cmd = item.cmd
        if (this.selectName === cmd) {
          return;
        }

        cmd = cmd.indexOf("#") === -1 ? cmd : cmd.split('#')[0]
        this.setSelectName(cmd); 
        if (this.refreshPage !== item.refreshPage) {
          this.setRefreshPage(item.refreshPage);
        }

        this.$router.push({path: item.linkUrl})
      },
      initApiList() {
        let menuList = JSON.parse(JSON.stringify(this.menuList));
        let apiList = []
        let self = this
        menuList.forEach((ele, index) => {
          // if (!ele.hidden) {
            var beginUri = ele.index
            let menus = ele.menu;
            let name = ele.name
            this.setApiListItem(self, beginUri, apiList, menus, name, ele.hidden);
          // }
        })
        this.apiList = apiList
      },
      setApiListItem(self, beginUri, apiList, menus, name, hidden) {
          menus.forEach(item => {
            // if (!item.hidden) {
              if (item.sub === undefined || item.sub.length === 0) {
                self.$set(item, "value", item.title)
                self.$set(item, "cmd", item.linkUrl)
                self.$set(item, "refreshPage", beginUri)
                item.linkUrl = beginUri + "/" + item.linkUrl
                item.hidden = item.hidden && item.hidden === true ? true : hidden
                apiList.push(item)
              } else{
                this.setApiListItem(self, beginUri, apiList, item.sub, name, hidden)
              }
            // }
          })
      }
    },
  };
</script>




// WEBPACK FOOTER //
// src/views/Api.vue